export default ($el) => ({
  el: $el,
  placeID: $el.dataset.gid,
  mapID: $el.dataset.mapid ?? null,
  locationUrl: '/ajax/location?gid=',
  status: 'loading',
  information: {},
  informationFormatted: {},
  hoursFormatted: false,
  reviews: [],
  rating: null,
  user_ratings_total: null,
  init() {
    if (this.placeID) {
      this.getInformation()
    }
    this.reInitMap()
  },

  getInformation() {
    const url = this.locationUrl + this.placeID
    fetch(url, {})
      .then((response) => response.json())
      .catch(() => {
        console.error('Error fetching' + url)
        this.status = 'error'
        return false
      })
      .then((json) => {
        this.information = json
        this.status = 'success'
        this.formatInformation()
      })
  },

  formatInformation() {
    if (
      !Object.keys(this.information).length > 0 ||
      !Object.keys(this.information.hours).length > 0
    ) {
      console.log('hours not at google')
      this.hoursFormatted = false
      return true
    }
    let format = []
    Object.values(this.information.hours).forEach((row) => {
      const values = this.splitDays(row)
      format.push(values)
    })

    this.hoursFormatted = format
  },

  reInitMap() {
    const googleMapInstance = window.googleMaps
    if (
      typeof (googleMapInstance !== 'undefined') &&
      googleMapInstance &&
      this.mapID
    ) {
      googleMapInstance.init(this.mapID)
    }
  },
  splitDays(string) {
    const day = string.slice(0, string.indexOf(':'))
    const time = string.slice(string.indexOf(':') + 1)

    return {
      day,
      time,
    }
  },
})
